module.exports = __webpack_public_path__ + "static/media/7-4.0058cc9a.mp3";